import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { VerifyOTPPageRoutingModule } from './verify-otp-routing.module';

import { VerifyOTPPage } from './verify-otp.page';
import { SharedDirectiveModule } from '@app/shared/directives/shared-directive.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    VerifyOTPPageRoutingModule,
    SharedDirectiveModule
  ],
  declarations: [VerifyOTPPage]
})
export class VerifyOTPPageModule {}
